import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex, HStack, Image, useColorModeValue } from "@chakra-ui/react";

import image1 from "../../assets/site-cav_7.png";
import image2 from "../../assets/site-cav_2.png";
import image3 from "../../assets/site-cav_6.jpg";

export default function MobileNewsCarousel() {
  const images = useMemo(() => [image1, image2, image3], []);
  const [idx, setIdx] = useState(0);

  const border = useColorModeValue("rgba(0,0,0,0.08)", "rgba(255,255,255,0.10)");
  const bg = useColorModeValue("white", "rgba(255,255,255,0.03)");
  const dotOff = useColorModeValue("rgba(0,0,0,0.18)", "rgba(255,255,255,0.20)");
  const dotOn = useColorModeValue("#315369", "white");

  const next = () => setIdx((i) => (i === images.length - 1 ? 0 : i + 1));

  useEffect(() => {
    const t = setInterval(next, 3200);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images.length]);

  return (
    <Box mt="150px" px={4}>
      <Box
        border="1px solid"
        borderColor={border}
        borderRadius="22px"
        bg={bg}
        overflow="hidden"
        boxShadow={useColorModeValue("0 12px 30px rgba(0,0,0,0.10)", "none")}
      >
        <Box aspectRatio={16 / 9} w="100%" overflow="hidden">
          <Image
            src={images[idx]}
            alt={`News slide ${idx + 1}`}
            w="100%"
            h="100%"
            objectFit="cover"
          />
        </Box>

        <Flex justify="center" py={3}>
          <HStack spacing={2}>
            {images.map((_, i) => (
              <Box
                key={i}
                w="9px"
                h="9px"
                borderRadius="full"
                bg={i === idx ? dotOn : dotOff}
                onClick={() => setIdx(i)}
              />
            ))}
          </HStack>
        </Flex>
      </Box>
    </Box>
  );
}
